var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',[_c('el-row',{staticClass:"U--flex-wrap",attrs:{"gutter":20,"no-gutters":"","type":"flex"}},_vm._l((_vm.dataGroups),function(dataGroup,key){return _c('el-col',{key:key,attrs:{"sm":12,"lg":8}},[_c('data-group',{attrs:{"dataGroup":dataGroup}})],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-357d24f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataGroupList.vue
// module id = null
// module chunks = 